A.ready(() => {
    new A.Widget({
        el: '.top-nav',
        events: {
            'mouseenter .first-item': 'calcSecondNavPosition',
        },
        created() {
            this.fixed = false;
            document.addEventListener('scroll', this.changeNavStatus);
        },
        beforeDestroyed() {
            document.removeEventListener('scroll', this.changeNavStatus);
        },
        methods: {
            // 计算二级导航的水平位置
            calcSecondNavPosition() {
                const navList = this.el.querySelectorAll('.first-item');
                const homeNav = navList[0];
                const firstNavList = Array.prototype.slice.call(navList, 1, -1);
                firstNavList.forEach(firstNav => {
                    const secondNav = firstNav.querySelector('ul');
                    if (secondNav && !secondNav.style.left) {
                        const width = secondNav.getBoundingClientRect().width;
                        if (width) {
                            secondNav.style.left = Math.max(homeNav.offsetLeft, firstNav.offsetLeft - width / 2) + 'px';
                        }
                    }
                });
            },
            // 计算页面滚动高度以设置导航栏定位
            changeNavStatus() {
                const scrollTop = document.documentElement.scrollTop;
                if (scrollTop >= 180 && !this.fixed) {
                    this.el.className += ' nav-fixed';
                    this.fixed = true;
                    this.el.parentElement.style.paddingTop = '10px';
                }
                if (scrollTop < 180 && this.fixed) {
                    this.el.className = 'top-nav';
                    this.fixed = false;
                    this.el.parentElement.style.paddingTop = '';
                }
            },
        },
    });
});